import API from '../api'

export type JobListItem = {
  jobId: number
  jobName: string
  customerName: string
  jobNo: string,
  propertyAddress1: string,
  propertyNickname: string
}

export type JobSearchResponse = {
  jobs: JobListItem[]
}

export const jobListEndpoint = `/web/jobs/search`

export type JobSearchParams = {
  openJobsOnly?: boolean
  searchTerm: string
  page: number
  activeJobsOnly?: boolean
  soldJobsOnly?: boolean
}

export const getJobList = async (params: JobSearchParams): Promise<JobListItem[]> => {
  return (await API.get<JobSearchResponse>(jobListEndpoint, { params })).data.jobs
}